/**
 *
 * MeasurementPreview
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { Button } from "antd"
import previewIcon from "../../images/preview-icon.svg"
import sendProofIcon from "../../images/send-proof-icon.svg"
import "./index.less"

import previewIconStep from "../../images/preview-step-icon.svg"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_btns, buttonAction_s } from "../Snowplow/config2"
// snowplow

let buttonAction_btn = (tipo) => {
  let data_button_prev = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: tipo,
    label: `Click a ${tipo}`,
    property: "button",
    value: LOCAL_USER_ID(),
  }
  buttonAction_s(data_button_prev)
}
/* eslint-disable react/prefer-stateless-function */
class MeasurementPreview extends React.Component {
  render() {
    return (
      <div className="measurement-preview">
        <img src={previewIconStep} />
        <div className="measurement-preview-description">
          <p>
            Si lo deseas, dale una <span>última revisada</span> a la encuesta
            previsualizándola o <br />
            enviando una simulación antes de agendarla.
          </p>
        </div>
        <div className="measurement-create-header-actions">
          <Button
            id="btnPrevisualizar"
            onClick={() => {
              this.props.isSelected("preview")
              buttonAction_btns("Previsualizar")
              window.open(
                `${process.env.QUESTIONNAIRE_URL}surveys/answers/${
                  this.props.measure.id_scope_type === 1
                    ? this.props.measure.id_survey
                    : this.props.measure.surveys[0].id_survey
                }`,
                "_blank"
              )
            }}>
            <img src={previewIcon} /> Previsualizar
          </Button>
          <Button
            onClick={() => {
              this.props.isSelected("send")
              buttonAction_btns("Enviar Prueba de medicion")
              this.props.handleModalChange("modalSendTestSurvey", true)
            }}>
            <img src={sendProofIcon} /> Enviar prueba
          </Button>
        </div>
      </div>
    )
  }
}

MeasurementPreview.propTypes = {}

export default MeasurementPreview
